import dates from 'utils/dates';
import Immutable from 'immutable';
import pandaUtils from 'utils/panda';

const DEFAULT_CALENDAR_DAYS_FROM_TODAY = 7;

const privateApi = {
  getCalendarDatesArray(selectedTimestamp, viewTimestamp, isDayUnavailable) {
    const selectedDate = dates.utcDate(selectedTimestamp);
    const selectedDay = selectedDate.getDate();
    const selectedMonth = selectedDate.getMonth();
    const selectedYear = selectedDate.getFullYear();

    const viewDate = dates.utcDate(viewTimestamp);
    const viewMonth = viewDate.getMonth();
    const viewYear = viewDate.getFullYear();

    const viewingSelectedMonth = viewMonth === selectedMonth && viewYear === selectedYear;

    const monthDays = [];
    const today = new Date();
    const firstOfViewedMonth = new Date(viewYear, viewMonth, 1);
    const monthLength = dates.numDaysInMonth(viewYear, viewMonth);

    const dayOfWeekOfFirst = firstOfViewedMonth.getDay();
    // take a day off before getting dayOfWeek so that monday=0
    const dayOfWeek = dayOfWeekOfFirst === 0 ? 6 : (dayOfWeekOfFirst - 1);

    for (let i = 0; i < monthLength; i++) {
      monthDays[i] = {
        day: i + 1,
        month: viewMonth,
        year: viewYear,
        unavailable: isDayUnavailable(i) || new Date(viewYear, viewMonth, i + 1) < today,
      };
    }
    if (viewingSelectedMonth) {
      monthDays[selectedDay - 1].highlight = 'selected';
    }

    for (let i = 0; i < dayOfWeek; i++) {
      monthDays.unshift(null);
    }

    const remainingDates = 7 - (monthDays.length % 7);

    for (let i = 0; i < remainingDates; i++) {
      monthDays.push(null);
    }

    return monthDays;
  },

  getDefaultDate() {
    return dates.parseDateStampToCalDate(dates.addDays(DEFAULT_CALENDAR_DAYS_FROM_TODAY));
  },

  getDepartureDate(baseState, isPanda = false, isDP = false, annualAvailability) {
    const queryProps = baseState.getIn(['queryState', 'props'], Immutable.Map());

    const calDate = queryProps.getIn(['calDate', 'value']);
    const calDateSelected = queryProps.getIn(['calDate', 'selected']);
    const deptDate = queryProps.getIn(['deptDate', 'value']);
    const deptDateSelected = queryProps.getIn(['deptDate', 'selected']);

    let date;
    // on PandA calDate takes precedence, else deptDate
    if (!isPanda && deptDate && deptDateSelected) {
      date = deptDate;
    } else if (calDateSelected) {
      date = calDate;
    } else if (deptDateSelected) {
      date = deptDate;
    } else if (isPanda && isDP) {
      pandaUtils.calculateCalDate({ baseState, annualAvailability });
    } else if (isPanda) {
      date = this.getDefaultDate();
    }

    return date;
  },
};

export { privateApi };

const api = {
  getCalendarDatesArray(selectedTimestamp, viewTimestamp, isDayUnavailable) {
    return privateApi.getCalendarDatesArray(selectedTimestamp, viewTimestamp, isDayUnavailable);
  },
  getDepartureDate(baseState, isPanda) {
    return privateApi.getDepartureDate(baseState, isPanda);
  },
  getDefaultDate() {
    return privateApi.getDefaultDate();
  },
};

export default api;



/** WEBPACK FOOTER **
 ** ./src/utils/calendar.js
 **/